<template>
  <div class="flex-middle flex-center padding-max-block flex-column gap-2xl padding-xl-horizontal"
       style="height: 100vh; height: 100lvh;">
    <img :src="getDynamicAssetUrl('core/images/logos/main.png')"
         :alt="t('core.genericAlt.imageOf',{thing: t('core.meta.siteName')})"
         class="logo max-width-400" />
    <h1>{{tt('core.meta.siteName')}}</h1>
  </div>
</template>

<script>

import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  components: {

  },
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus};
  },
  layout: "default",
  meta: "core.defaultPage.mainTitle",
  data() {
    return {
      homepageData: false,
      asyncData: {

      }
    }
  },
  computed: {

  }
};
</script>

<style lang="scss" scoped></style>
